// extracted by mini-css-extract-plugin
export default {"root":"Img_root__dJJRH"};